import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes safely
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format duration in seconds to MM:SS
 */
export function formatDuration(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Format processing time
 */
export function formatProcessingTime(ms) {
  return `${(ms / 1000).toFixed(1)}s`;
}

/**
 * Truncate text with ellipsis
 */
export function truncate(text, maxLength = 100) {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + '...';
}

/**
 * Get expert info from registry with fallback
 */
export function getExpertInfo(name, registry) {
  return registry[name] || {
    role: 'Expert',
    emoji: '💡',
    color: '#A1A1AA',
    gender: 'neutral'
  };
}

/**
 * Calculate confidence color
 */
export function getConfidenceColor(confidence) {
  if (confidence >= 0.8) return '#14B8A6'; // Teal - High
  if (confidence >= 0.6) return '#F59E0B'; // Gold - Medium
  return '#EF4444'; // Red - Low
}

/**
 * Delay utility for animations
 */
export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Infer gender from name for avatar
 */
export function inferGender(name) {
  if (!name) return 'neutral';
  const firstName = name.split(' ')[0].toLowerCase();
  
  // Common female names
  const femaleNames = [
    'april', 'teresa', 'elena', 'maggie', 'sarah', 'emily', 'jessica',
    'jennifer', 'amanda', 'lisa', 'nicole', 'michelle', 'stephanie',
    'rachel', 'laura', 'heather', 'amy', 'anna', 'rebecca', 'katherine'
  ];
  
  if (femaleNames.includes(firstName)) return 'female';
  return 'male';
}
